<section class="reference-range-page">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Reference Range Templates</mat-card-title>
      <mat-card-subtitle>Configure normal/abnormal boundaries for specific observation codes.</mat-card-subtitle>
      <span class="spacer"></span>
      <button mat-raised-button color="primary" (click)="openAddDialog()">
        <mat-icon>add</mat-icon>
        Add New Range
      </button>
    </mat-card-header>

    <mat-card-content>
      <div class="actions-wrapper">
        <div class="actions">
          <button mat-stroked-button color="accent" (click)="downloadCommonTemplateExcel()">
            <mat-icon>library_books</mat-icon>
            Download Pre-filled Template
          </button>
          <button mat-stroked-button (click)="downloadTemplateExcel()">
            <mat-icon>download</mat-icon>
            Download Excel Template
          </button>
          <button mat-stroked-button (click)="fileInput.click()">
            <mat-icon>upload</mat-icon>
            Import from Excel
          </button>
          <input hidden #fileInput type="file" accept=".xlsx" (change)="onFileSelected($event)">
          
          <span class="spacer"></span>
          
          <button mat-stroked-button (click)="downloadTemplatesAsExcel()" [disabled]="templates.length === 0">
            <mat-icon>file_download</mat-icon>
            Export All to Excel
          </button>
        </div>
      </div>

      @if(loadingTemplates) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      } @else {
        @if(templates.length === 0) {
          <p class="empty-state">No reference ranges configured yet. Click "Add New Range" to get started.</p>
        } @else {
          <table mat-table [dataSource]="templates" class="range-table">
            <ng-container matColumnDef="code">
              <th mat-header-cell *matHeaderCellDef>Observation</th>
              <td mat-cell *matCellDef="let template">
                <div class="code-cell">
                  <div class="primary">{{ template.display }}</div>
                  <div class="secondary">{{ template.code?.code }}</div>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="range">
              <th mat-header-cell *matHeaderCellDef>Range</th>
              <td mat-cell *matCellDef="let template">{{ rangeSummary(template.range) }}</td>
            </ng-container>

            <ng-container matColumnDef="appliesTo">
              <th mat-header-cell *matHeaderCellDef>Applies To</th>
              <td mat-cell *matCellDef="let template">
                @if(template.range?.appliesTo?.length) {
                  <mat-chip-set>
                    @for(group of template.range?.appliesTo ?? []; track group.text ?? group.coding?.[0]?.code) {
                      <mat-chip style="padding: 2px 5px 2px 8px !important; background: var(--mat-sys-surface-low); border:none !important;">
                        {{ group.text || group.coding?.[0]?.display || group.coding?.[0]?.code }}
                      </mat-chip>
                    }
                  </mat-chip-set>
                } @else {
                  <span>All patients</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="age">
              <th mat-header-cell *matHeaderCellDef>Age</th>
              <td mat-cell *matCellDef="let template">{{ ageSummary(template.range) }}</td>
            </ng-container>

            <ng-container matColumnDef="updated">
              <th mat-header-cell *matHeaderCellDef>Last Updated</th>
              <td mat-cell *matCellDef="let template">{{ template.lastUpdated | date:'medium' }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let template">
                <button mat-icon-button color="primary" (click)="editTemplate(template)" matTooltip="Edit Range">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteTemplate(template)" matTooltip="Delete Range">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        }
      }
    </mat-card-content>
  </mat-card>
</section>
